import { Component  } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  title = 'app';

  
}



// WEBPACK FOOTER //
// C:/Users/gbelizaire/Documents/ang2tut/resulatbac/src/app/app.component.ts